import { type MetaFunction } from "@remix-run/node";



export default function Index() {
  return (
    <div></div>
  );
}
